import { 
  Box, 
  Typography, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem,
  TextField,
  IconButton,
  FormHelperText
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export function CampaignNodeFields({ 
  localNodeData, 
  updateNodeData,
  accountList,
  templateList,
  dispatch,
  listTemplatesAPI,
  readTemplateAPI,
  options,
  error,
  handleOptionChange,
  deleteOption,
  addOption
}) {
  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
          Opciones de Cuenta
        </Typography>
        <FormControl fullWidth>
          <InputLabel id="account-select-label">Cuenta</InputLabel>
          <Select
            labelId="account-select-label"
            value={localNodeData.accountId || ''}
            label="Cuenta"
            onChange={(e) => {
              updateNodeData('accountId', e.target.value);
              updateNodeData('templateId', '');
              dispatch(listTemplatesAPI(e.target.value));
            }}
          >
            {accountList.map((account) => (
              <MenuItem key={account.id} value={account.id}>
                {account.number}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box>
        <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
          Opciones de Campaña
        </Typography>
        <FormControl fullWidth>
          <InputLabel id="template-select-label">Plantilla de campaña</InputLabel>
          <Select
            labelId="template-select-label"
            value={localNodeData.templateId || ''}
            label="Plantilla de campaña"
            onChange={(e) => {
              const templateId = e.target.value;
              updateNodeData('templateId', templateId);
              if (templateId) {
                dispatch(readTemplateAPI(templateId));
              }
            }}
            disabled={!localNodeData.accountId}
          >
            {templateList.map((template) => (
              <MenuItem key={template.id} value={template.id}>
                {template.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ mt: 2 }}>
        <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
          Opciones de Respuesta
        </Typography>
        {options.map((option) => (
          <div key={option.id}>
            <Box
              sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'center' }}
            >
              <TextField
                value={option.title}
                size="small"
                fullWidth
                placeholder="Escribe una opción"
                onChange={(e) => handleOptionChange(option.id, e.target.value, "campaign")}
                error={!!error[option.id]}
              />
              <IconButton
                size="small"
                onClick={() => deleteOption(option.id)}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
            {error[option.id] && (
              <FormHelperText error>{error[option.id]}</FormHelperText>
            )}
          </div>
        ))}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={addOption} size="small">
            <Typography variant="body2" color="primary">
              + Agregar Opción
            </Typography>
          </IconButton>
        </Box>
      </Box>
    </>
  );
}